export default [
  {
    width: 15,
    header: {
      type: 'text',
      caption: 'Group',
    },
    cell: {
      type: 'slot',
      name: 'group',
    },
  },
  {
    width: 30,
    header: {
      type: 'text',
      caption: 'Accesses',
    },
    cell: {
      type: 'slot',
      name: 'accesses',
    },
  },
  {
    width: 55,
    header: {
      type: 'text',
      caption: 'Bans',
    },
    cell: {
      type: 'slot',
      name: 'bans',
    },
  },
];
